<template>
  <v-app>
        <div id="header">
          <div id="titlesection" class="mx-12">
            <h1 class="mt-10 mb-12">Theodore Weeden</h1>
            <h2>Poetry Portfolio</h2>
          </div>
          <div class="navbar"> 
            <router-link to="/">NATURE</router-link> |
            <router-link to="/surreal">SURREAL</router-link> |
            <router-link to="/about">ABOUT</router-link>
          </div>
        </div>
        <transition name="fade" mode="out-in">
          <router-view/>
        </transition>
        <div id="footer">
          <hr>
          <p class="text-center my-6">Copyright 2020 · Theodore Weeden</p>
        </div>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
    
  },
  data: () => ({
    
  }),
  created(){
    
  }
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Slabo+27px&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Parisienne&family=Slabo+27px&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap');

  $body-width: 1100px;

  #app{
    background: white;
  }

  #header{
    width:100%;
    position: absolute;
    top: 0;
    z-index: 100;
  }

  .navbar{ 
    text-align: center;
    position: absolute;
    width: 100%;
    top: 120px;
    padding: 9px 0;
  }

  .navbar a{
    text-decoration: none;
    padding: 0 2px;
  }

  .body{
    max-width: $body-width;
    margin: 0 auto;
  }

  #titlesection h1{
    font-family: 'Slabo 27px', serif;
    font-weight: bold;
    line-height: 110px;
    margin: 0px 0px 85px;

    font-size: 50px;
    display: inline;
  }
  
  #titlesection{
    border-bottom: solid black 2px;
  }

  #footer hr{
    margin: 0 !important;
  }

  #titlesection h2{
    font-family: 'Parisienne', cursive;
    font-size: 50px;
    display: inline;
    float: right;
    line-height: 110px;
  }

  #titlesection h2::before{
    content: " ";
    background: rgba(173, 216, 230, 0.7);
    height: 5px;
    width: 302px;
    position: absolute;
    bottom: 35px;
  }

  .darkHeader #app{
    background: black;
  }

  .darkHeader #titlesection{
    color: white;
    border-color: white;
  }

  .darkHeader .navbar{
    color: white;
    font-family: 'Roboto Slab', serif;
  }

  .darkHeader .navbar a{
    color: white !important;
    background: black;
  }
  
  .darkHeader #footer{
    color: white;
  }

  .lightHeader #app{
    background: white;
  }

  .lightHeader #titlesection{
    color: black;
    background: white;
  }
  
  .lightHeader .navbar{
    color: black;
    font-family: 'Roboto Slab', serif;
  }
  
  .lightHeader .navbar a{
    color: black !important;
  }

  .poemContainer:first-of-type{
    min-height: 1100px;
  }

  .poemContainer{
    width: 100%;
    min-height: 1000px;
    display: flex;
    align-items: center;
    font-family: 'Roboto Slab', serif;
  }

  .poem{
    z-index: 20;
    width: 550px;
    margin: 0 auto;
    padding: 15px 20px;
    color: black;
    background: radial-gradient(rgba(245, 250, 252, 0.85), #FFFFFF);
  }

  .poem p{
    font-size: 100%;
  }

  //small screens
  @media (max-width: 960px) {
    #header{
      position: relative;
      margin-top: 20px;
    }

    #titlesection{
      display: block;
      padding-bottom: 20px;
    }

    #titlesection h1{
      line-height: 60px;
    }
    
    #titlesection h2{
      line-height: 60px;
      float: none;
      display: block;
    }
    
    #titlesection h2::before{
      width: 300px;
      bottom: 30px;
    }
    
    .navbar{
      top: 150px;
    }
  }

  //phones
  @media (max-width: 600px) {
    #header{
      max-width: 400px;
      margin-bottom: 55px;
    }

    .navbar{
      top: 270px;
    }

    #titlesection h2::before{
      width: 156px;
    }

    .poemContainer{
      min-height: auto;
      background-image: none !important;
    }
    
    .darkHeader.nature #app{
      background-image: url("./assets/ocean.png") !important;
      background-size: cover;
      background-position: -200px -400px;
    }
    
    .darkHeader.surreal #app{
      background-image: url("./assets/cogitations.png") !important;
      background-size: cover;
    }
  }

  .fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

</style>

